import { Trans } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import Checkbox from "components/DesignComponents/Checkbox";
import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import { useTranslatedExternalLinks } from "shared/hooks/useTranslatedExternalLinks";

import { TermsAndConditionsProps } from "./types";

const TermsAndConditions = ({
    isDisabled,
    toggleValue
}: TermsAndConditionsProps) => {
    const { gray200 } = colors;

    const { dataProcessingAgreement, termsOfService } =
        useTranslatedExternalLinks();

    return (
        <div
            css={css({
                borderTop: `1px solid ${gray200}`
            })}
        >
            <Checkbox
                label={
                    <Trans
                        i18nKey="Auth##user consent text"
                        components={{
                            1: (
                                <TextLink
                                    size={TEXT_LINK_SIZES.Normal}
                                    href={termsOfService}
                                    target="_blank"
                                    isDisabled={isDisabled}
                                    css={css({ display: "inline" })}
                                >
                                    Terms of Service
                                </TextLink>
                            ),
                            2: (
                                <TextLink
                                    size={TEXT_LINK_SIZES.Normal}
                                    href={dataProcessingAgreement}
                                    target="_blank"
                                    isDisabled={isDisabled}
                                    css={css({ display: "inline" })}
                                >
                                    Data Processing Agreement
                                </TextLink>
                            )
                        }}
                    />
                }
                disabled={isDisabled}
                onChange={(_, value) => toggleValue(value)}
                customStyle={{ margin: "16px 0" }}
            />
        </div>
    );
};

export default TermsAndConditions;
